var _mask, _rect, _rect2, _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_7_6138",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 2.5332,
    width: 17.8127,
    height: 21.4366,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2.5332,
    width: 17.8127,
    height: 21.4366,
    rx: 1,
    stroke: "#333333",
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_7_6138)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.27539,
    y: 1,
    width: 7.26251,
    height: 4.56152,
    rx: 1,
    fill: "#EA088B",
    stroke: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.30078,
    y1: 15.8125,
    x2: 13.5124,
    y2: 15.8125,
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4.30078,
    y1: 19.6411,
    x2: 13.5124,
    y2: 19.6411,
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 8.9089,
    y1: 11.7541,
    x2: 6.39361,
    y2: 8.01053,
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: -0.75,
    x2: 5.26011,
    y2: -0.75,
    transform: "matrix(0.5577 -0.830043 -0.830043 -0.5577 7.86804 11.9584)",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: -0.75,
    x2: 5.26011,
    y2: -0.75,
    transform: "matrix(0.5577 -0.830043 -0.830043 -0.5577 2.83643 11.9584)",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 13.9359,
    y1: 11.7541,
    x2: 11.4206,
    y2: 8.01053,
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterListIcon);
export default __webpack_public_path__ + "static/media/master-list-icon.c82415318e8dea2c011c9f2018fe3596.svg";
export { ForwardRef as ReactComponent };